import React from 'react';
import { IonButton, IonContent, IonToolbar } from '@ionic/react';
import SearchBar from 'components/searchbar/SearchBar';
import BackButtonHeader from 'core/layout/BackButtonHeader';
import LoadingIonList from 'core/layout/loading-ion-list/LoadingIonList';
import DocumentsListView from 'features/shared/documents/components/DocumentsListView';
import { Document } from 'core/types';
import ViewModeToggle from 'features/shared/documents/components/ViewModeToggle';
import { ViewMode } from 'features/shared/documents/DocumentsSlice';
import DocumentsGridView from 'features/shared/documents/components/DocumentsGridView';

interface MobileDocumentsViewProps {
  type: string;
  search: string;
  onSearchChange: (value: string) => void;
  documents: Document[];
  filteredDocuments: Document[];
  loading: boolean;
  viewMode: ViewMode;
  documentTypeLabel: string;
  onAddDocument: (type: string) => void;
  onDocumentClick: (document: any) => void;
}

const MobileDocumentsView: React.FC<MobileDocumentsViewProps> = ({
  type,
  search,
  onSearchChange,
  documents,
  filteredDocuments,
  loading,
  viewMode,
  documentTypeLabel,
  onAddDocument,
  onDocumentClick
}) => {
  return (
    <>
      <BackButtonHeader
        title={documentTypeLabel}
        url={
          type && type.startsWith('construction')
            ? '/documents/group/construction'
            : '/documents'
        }
      />
      <IonContent fullscreen>
        <div id="hk-mobile-digital-documents-list-header">
          <div className="hk-mobile-digital-documents-list-header-search">
            <SearchBar
              value={search}
              disabled={documents?.length === 0}
              onSearchChange={onSearchChange}
            />
          </div>
          <div className="hk-mobile-digital-documents-list-header-view-mode">
            <ViewModeToggle
              currentViewMode={viewMode}
              itemCount={filteredDocuments.length}
            />
          </div>
        </div>

        <LoadingIonList
          items={filteredDocuments}
          className={`hk-digital-document-list ion-margin-horizontal ${type}`}
          label={documentTypeLabel}
          loading={loading}
        >
          {viewMode === ViewMode.LIST ? (
            <DocumentsListView
              documents={filteredDocuments}
              onDocumentClick={onDocumentClick}
            />
          ) : (
            <DocumentsGridView
              documents={filteredDocuments}
              onDocumentClick={onDocumentClick}
            />
          )}
        </LoadingIonList>
      </IonContent>
      <IonToolbar className="hk-mobile-digital-documents-list-toolbar">
        <IonButton
          expand="block"
          color="primary"
          strong={true}
          onClick={() => onAddDocument(type)}
        >
          Add Document
        </IonButton>
      </IonToolbar>
    </>
  );
};

export default MobileDocumentsView;
